import { defineMessages } from 'react-intl';

const upgradeContactsMessages = defineMessages({
  featureName: {
    id: 'unlock.contacts',
    defaultMessage: 'Contacts',
  },
  featureHeading: {
    id: 'unlock.contacts.heading',
    defaultMessage: 'Unlock Contacts',
  },
  featureSummary: {
    id: 'unlock.contacts.summary',
    defaultMessage: 'Save time, keep your RepVisits contacts all in one place',
  },
  featureUnlockDetails: {
    id: 'unlock.contacts.details',
    defaultMessage: `Contacts helps you easily find the contact information for previous and
                    upcoming appointments. Search by name or institution, and add private notes to 
                    any contact.`,
  },
});

export default upgradeContactsMessages;
